import moment from 'moment-timezone';
import uuid from 'uuid/v1';

import { WEEK_DAYS, WEEKLY_BASE} from '../../constants/base';

const WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
const WEEKENDS = ['Sat', 'Sun'];

export const DEFAULT_LANGUAGE = 'English';
export const AVAILABLE_LANGUAGES = ['English', 'Norwegian'];

export const RENTAL_ITEMS_TAB = 2;



export const RENTAL_ITEMS_FORMS_NUMBERS = {
    generalForm: 0,
    descriptionForm: 1,
    pricesForm: 2,
    rentedOutDatesForm : 3,
    addOnsForm: 4
};



export const PRICES_PER_DAY = {
    USD: '0',
    EUR: '0',
    NOK: '0'
};
export const INITIAL_RENTAL_ITEMS_FORM_DATA = {
    generalForm: {
        productCode: '',
         coverPhoto: {},
    },
    descriptionForm: {},
    pricesFixedForm: {
        USD: '0',
        EUR: '0',
        NOK: '0'
    },
    pricesDailyForm: {
        days: WEEK_DAYS.map(day => ({
        id: uuid(),
        day: day,
        type: 'day',
        ...PRICES_PER_DAY
        }))
    },
    pricesWeeklyForm : {
    weekList: WEEKLY_BASE.map(type => ({
        id: uuid(),
        type: type,
        days: type === 'weekday' ? WEEKDAYS : WEEKENDS,
        ...PRICES_PER_DAY
    }))
    },
    pricesHourlyForm: {
       hourlyList: [
    {
      id: uuid(),
      time: 'Master Price',
      startTime: null,
      isMaster: true,
      minHours: '1',
      maxHours: '24',
      ...PRICES_PER_DAY
    }
  ]
    },
    rentedOutDatesForm: {
        rentedOutList:[]
    },
    addOnsForm: {
        addOns: []
    }
};

export const RENTAL_ITEMS_FORMS_ORDER = [
    'generalForm',
    'descriptionForm',
    {
        0: 'pricesFixedForm',
        1: 'pricesDailyForm',
        2: 'pricesWeeklyForm',
        3: 'pricesHourlyForm'
    },
    'rentedOutDatesForm',
    'addOnsForm'
];

export const RENTAL_ITEMS_PRICES_FORMS_NUMBERS = {
  pricesFixedForm: 0,
  pricesDailyForm: 1,
  pricesWeeklyForm: 2,
  pricesHourlyForm: 3
};
